export default "__VITE_ASSET__BoShnB$G__"